//Types
export var ORDERS_RESET_ACTION_TYPE = "orders/reset";
export var ORDERS_GET_START_ACTION_TYPE = "orders/get_start";
export var ORDERS_GET_SUCCESS_ACTION_TYPE = "orders/get_success";
export var ORDERS_GET_STATUS_START_ACTION_TYPE = "orders/get_status_start";
export var ORDERS_GET_STATUS_SUCCESS_ACTION_TYPE = "orders/get_status_success";
export var ORDERS_MIGRATE_START_ACTION_TYPE = "orders/migrate_start";
export var ORDERS_MIGRATE_SUCCESS_ACTION_TYPE = "orders/migrate_success";
export var ORDERS_RELOAD_START_ACTION_TYPE = "orders/reload_start";
export var ORDERS_RELOAD_SUCCESS_ACTION_TYPE = "orders/reload_success";
export var ORDERS_SAVE_START_ACTION_TYPE = "orders/save_start";
export var ORDERS_SAVE_SUCCESS_ACTION_TYPE = "orders/save_success";
export var ORDERS_SAVE_REDEEM_START_ACTION_TYPE = "orders/save_redeem_start";
export var ORDERS_SAVE_REDEEM_SUCCESS_ACTION_TYPE = "orders/save_redeem_success";
export var ORDERS_SAVE_NOTES_START_ACTION_TYPE = "orders/save_notes_start";
export var ORDERS_SAVE_NOTES_SUCCESS_ACTION_TYPE = "orders/save_notes_success";
export var ORDERS_SAVE_ITEM_START_ACTION_TYPE = "orders/save_item_start";
export var ORDERS_SAVE_ITEM_SUCCESS_ACTION_TYPE = "orders/save_item_success";
export var ORDERS_DELETE_ITEM_START_ACTION_TYPE = "orders/delete_item_start";
export var ORDERS_DELETE_ITEM_SUCCESS_ACTION_TYPE = "orders/delete_item_success";
export var ORDERS_DELETE_PET_FROM_ORDER_START_ACTION_TYPE = "orders/delete_pet_from_order_start";
export var ORDERS_DELETE_PET_FROM_ORDER_SUCCESS_ACTION_TYPE = "orders/delete_pet_from_order_success";
export var ORDERS_VERIFY_OUTDATED_START_ACTION_TYPE = "orders/verify_outdated_start";
export var ORDERS_VERIFY_OUTDATED_SUCCESS_ACTION_TYPE = "orders/verify_outdated_success";
export var ORDERS_NOT_FOUND_ACTION_TYPE = "orders/not_found";
export var ORDERS_UNPROCESSABLE_ACTION_TYPE = "orders/unprocessable";
export var ORDERS_ERROR_ACTION_TYPE = "orders/error";
